<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :calculoCodigo="true" :objeto="state.objetoAuxiliar" :temLink="true" :link="state.link"
        :calcularCodigo="calcularCodigo" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao"
                        placeholder="Descrição">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código Leito
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.codigoLeito">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Quarto
                </label>
                <div class="col inp">
                    <select name="" id="" class="form-select" v-model="state.objetoAuxiliar.quarto">
                        <option v-for="q in state.quartos" :key="q" :value="q"> {{ q.descricaoCompleta }} </option>
                    </select>
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import { frontUrl } from "@/api/const";
import store from '@/store/store';
import api from '@/api/api';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Descrição', 'Código', 'Código do Leito', 'Quarto', 'Ativo'],
    linhas: ['descricao', 'id', 'codigoLeito', 'quarto', 'ativo'],
    url: "Leito",
    titulo: "Cadastro de Leito",
    objetoAuxiliar: {
        ativo: Boolean()
    },
    link: frontUrl,
    quartos: [],
    lstObrigatorios: ['descricao', 'codigoLeito', 'quarto'],
    lstObrigatoriosLabel: ['Descrição', 'Código do Setor', 'Quarto'],
});

onMounted(async () => {
    await api.listaDinamica("/api/quarto/listar")
        .then(resp => {
            state.quartos = resp;
        });
});

async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
        state.objetoAuxiliar.ativo = true;
    }
}
function calcularCodigo() {
    // if (state.objetoAuxiliar.codigoLeito.includes('.')) {
    //     let aux = state.objetoAuxiliar.codigoLeito.lastIndexOf(".");
    //     let tamanho = state.objetoAuxiliar.codigoLeito.length;
    //     let codigo = `${state.objetoAuxiliar.quarto.codigoQuarto}`;
    //     for (let i = aux; i < tamanho; i++) {
    //         codigo += state.objetoAuxiliar.codigoLeito[i];
    //     }
    //     state.objetoAuxiliar.codigoLeito = codigo;
    // } else {
    //     state.objetoAuxiliar.codigoLeito = `${state.objetoAuxiliar.quarto.codigoQuarto}.${state.objetoAuxiliar.codigoLeito}`;
    // }
}

const setor = computed(() => {
    return store.state.setores;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>